import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/node_modules/.pnpm/@una-ui+content@48.2.0_@parcel+watcher@2.5.1_@types+node@22.16.5_@unhead+vue@2.0.12_vue_7bbb611ebc9760b773bcbb23c662e4c1/node_modules/@una-ui/content/layouts/default.vue").then(m => m.default || m))
}